import React from "react";

export function Input({
  label,
  id,
  error,
  type = "text",
  required = false,
  className = "",
  ...props
}) {
  return (
    <div className="form-group">
      {label && (
        <label htmlFor={id} className="form-label">
          {label} {required && <span style={{ color: "var(--danger)" }}>*</span>}
        </label>
      )}
      <input
        id={id}
        type={type}
        required={required}
        className={`form-control ${className}`}
        {...props}
      />
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default Input;
